import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Card } from "@mui/material";
import {} from "@mui/icons-material";
import ZoomMtgEmbedded from "@zoomus/websdk/embedded";
const KJUR = require("jsrsasign");

const client = ZoomMtgEmbedded.createClient();

const meetingApp = {
  clientId: "oonS4VXjTsiXEvhS4VSKZg",
  clientSecret: "tuC0sM1Say3tU0T9aHF0ilxF78CXs1zB",
  featureSecret: "Jptv2zvoTYyGtSSgEsnssA",
  featureVerification: "UwkmD3ShQdW-4-yOnuaFMAv",
  code: "wI04aKa4j22bl___87JQVSOXl9kg5QlmQ",
  meetingNumber: 83926382808,
  password: "123456",
  role: 0,
};

const getLocalSignature = () => {
  const iat = Math.round(new Date().getTime() / 1000) - 30;
  const exp = iat + 60 * 60 * 2;
  const oHeader = { alg: "HS256", typ: "JWT" };
  const oPayload = {
    sdkKey: meetingApp.clientId,
    mn: meetingApp.meetingNumber,
    role: meetingApp.role,
    iat: iat,
    exp: exp,
    appKey: meetingApp.clientId,
    tokenExp: iat + 60 * 60 * 2,
  };
  const sHeader = JSON.stringify(oHeader);
  const sPayload = JSON.stringify(oPayload);
  const signature = KJUR.jws.JWS.sign(
    "HS256",
    sHeader,
    sPayload,
    meetingApp.clientSecret
  );
  return signature;
};

const joinMeeting = () => {
  const signature = getLocalSignature();
  console.log("try to join");
  console.log(signature);
  client.join({
    sdkKey: meetingApp.clientId,
    signature: signature,
    meetingNumber: meetingApp.meetingNumber,
    password: meetingApp.password,
    userName: "React",
  });
};

const ZoomSection = () => {
  setTimeout(() => {
    let meetingSDKElement = document.getElementById("meetingSDKElement");
    client.init({
      zoomAppRoot: meetingSDKElement,
      language: "en-US",
      customize: {
        video: {
          isResizable: true,
          viewSizes: {
            default: {
              width: 1000,
              height: 600,
            },
            ribbon: {
              width: 300,
              height: 700,
            },
          },
        },
      },
    });
  }, 1000);

  return (
    <>
      <Card
        id="meetingSDKElement"
        sx={{
          p: 2,
        }}
      >
        meetingSDKElement
      </Card>
      <button onClick={joinMeeting}>Join Meeting</button>
    </>
  );
};

const f = () => {};

export { ZoomSection, f };
